/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {WorkplaceState} from '../models/workplaceState';

export class WorkplaceStateStore extends EntityStore {
  workplaceStates = [];

  constructor(rootStore) {
    super(rootStore, 'workplaceStates', Api.workplaceStates, WorkplaceState);
  }

  update(entity, options = {}) {
    const updateAction = super.update(entity, options);
    updateAction.then((res) => {
      if (res.isDefault) {
        this.resetIsDefault([res.id]);
      }
    });
    return updateAction;
  }

  create(entity, options = {}) {
    const createAction = super.create(entity, options);
    createAction.then((res) => {
      if (res.isDefault) {
        this.resetIsDefault([res.id]);
      }
    });
    return createAction;
  }

  resetIsDefault(exceptIds = []) {
    this.workplaceStates = this.workplaceStates.map((state) => {
      if (state.isDefault && !exceptIds.includes(state.id)) {
        state.isDefault = false;
      }
      return state;
    });
  }
}

decorate(WorkplaceStateStore, {
  workplaceStates: observable,
});
